import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const LogoutButton = () => {
  const { logout } = useAuth0();

  return (
    <button
      onClick={() => logout({ 
        logoutParams: { 
          returnTo: window.location.origin 
        } 
      })}
      style={{
        padding: '10px 22px',
        backgroundColor: 'rgba(255,255,255,0.12)',
        color: '#ffffff',
        border: '1px solid rgba(255,255,255,0.35)',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '600',
        position: 'relative',
        zIndex: 102,
        transition: 'all 0.2s ease',
        letterSpacing: '0.3px'
      }}
      onMouseEnter={e => { e.target.style.backgroundColor = 'rgba(255,255,255,0.25)'; }}
      onMouseLeave={e => { e.target.style.backgroundColor = 'rgba(255,255,255,0.12)'; }}
    >
      Log Out
    </button>
  );
};

export default LogoutButton;
